(function() {
  "use strict";

  function printerQueueAccordionService($location, localStorageService, $cookies) {

    var storageObject = null;
    if (localStorageService.isSupported) {
      storageObject = localStorageService;
    } else {
      storageObject = $cookies;
      storageObject.set = function(key, value) {
        return storageObject.put(key, value);
      };
    }

    function calculateHeightOfQueueElement(printer) {
      var maxHeight = 0;
      var baseHeight = 65;
      var rowHeight = 54 * printer.resources.queues.length;
      maxHeight = baseHeight + rowHeight;
      return maxHeight;
    }

    function createPrintersQueueStateMap(printerList) {
      var printersQueueStateMap = {};
      for (var i = 0; i < printerList.length; i++) {
        var key = printerList[i].info._links.self.href;
        printersQueueStateMap[key] = {
          state: false,
          maxHeight: calculateHeightOfQueueElement(printerList[i])
        };
      }
      return printersQueueStateMap;
    }

    function checkPrintersQueueState(printerList) {
      var printersQueueStateMap = createPrintersQueueStateMap(printerList);
      for (var key in printersQueueStateMap) {
        if (key === storageObject.get('openQueue') && !printersQueueStateMap[key].state) {
          printersQueueStateMap[key].state = true;
        } else if (key === storageObject.get('openQueue') && printersQueueStateMap[key].state) {
          printersQueueStateMap[key].state = false;
        } else {
          printersQueueStateMap[key].state = false;
        }
      }
      return printersQueueStateMap;
    }

    function updateQueueState(printerURL, printerList)  {
      if (storageObject.get('openQueue') === printerURL) {
        storageObject.set('openQueue', null);
      } else {
        storageObject.set('openQueue', printerURL);
      }
      return checkPrintersQueueState(printerList);
    }

    function isGroupsEnabled(queues) {
      var hasGroups = false;
      for (var i = 0; i < queues.length; i++) {
        if (queues[i].info.groupsEnabled) {
          hasGroups = true;
          return hasGroups;
        }
      }
      return hasGroups;
    } 

    return {
      createPrintersQueueStateMap: createPrintersQueueStateMap,
      checkPrintersQueueState: checkPrintersQueueState,
      updateQueueState: updateQueueState,
      calculateHeightOfQueueElement: calculateHeightOfQueueElement,
      isGroupsEnabled: isGroupsEnabled
    }
  }

  printerQueueAccordionService.$inject = ['$location', 'localStorageService', '$cookies'];

  angular
    .module('printix-admin')
    .service('PrinterQueueAccordionService', printerQueueAccordionService);

})();